import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getPhotoById, updatePhoto } from "../../lib/firebase/firestore";
import { Photo } from "../../types";

export const EditPhotoGalleryPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [photo, setPhoto] = useState<Photo | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadPhoto = async () => {
      if (!id) return;
      const data = await getPhotoById(id);
      if (data) setPhoto(data);
    };
    loadPhoto();
  }, [id]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setPhoto((prev) => prev && { ...prev, [name]: value });
  };

  const handleTagChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const tags = e.target.value.split(",").map((t) => t.trim());
    setPhoto((prev) => prev && { ...prev, tags });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!photo || !photo.imageUrl) return alert("Please enter an image URL");

    setLoading(true);
    try {
      await updatePhoto(id!, {
        ...photo,
        year: photo.year ? parseInt(photo.year.toString()) : undefined,
      });
      alert("Photo updated successfully!");
      navigate("/admin/photos");
    } catch (error) {
      console.error(error);
      alert("Failed to update photo");
    }
    setLoading(false);
  };

  if (!photo) return <div>Loading...</div>;

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Edit Photo</h2>
      <form onSubmit={handleSubmit}>
        <input
          name="title"
          value={photo.title}
          onChange={handleChange}
          required
        />
        <textarea
          name="description"
          value={photo.description}
          onChange={handleChange}
        />
        <input
          name="tags"
          value={photo.tags?.join(", ") || ""}
          onChange={handleTagChange}
        />
        <input
          name="year"
          type="number"
          value={photo.year || ""}
          onChange={handleChange}
        />
        <input
          name="imageUrl"
          type="url"
          value={photo.imageUrl}
          onChange={handleChange}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Saving..." : "Update Photo"}
        </button>
      </form>
    </div>
  );
};
